import { styled } from '@mui/material/styles';
import { Toolbar } from '@mui/material';

// The grid toolbar row (Cabinet Base). Every control in it — search, date
// range, filter selects, ToolbarDropdownButton — is toolbar-control-height
// tall with radius-toolbar-control corners, so the row reads as one line of
// equal controls whatever a grid puts in it.
//
// The fields are `size="small"` (40px) everywhere else; here they stretch to
// the toolbar height. The resting label moves down by the same 2px so it stays
// centred; once it shrinks onto the border it sits where it always does.
export const StyledRoot = styled(Toolbar)(({ theme }) => ({
    minHeight: theme.sizes.toolbarCardMinHeight,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 2),
    gap: theme.spacing(1),
    overflow: 'hidden',
    '& .MuiOutlinedInput-root': {
        minHeight: theme.sizes.toolbarControlHeight,
        borderRadius: theme.shape.toolbarControl,
    },
    '& .MuiInputLabel-sizeSmall:not(.MuiInputLabel-shrink)': {
        transform: 'translate(14px, 11px) scale(1)',
    },
}));
